interface PropsType {
  searchUrl: string
}

const SearchButton = (props: PropsType) => {
  return (
    <a href={props.searchUrl} className="ext-button-primary h-13 w-54 px-8">
      この条件で検索する
    </a>
  )
}

export default SearchButton
